<div class="modal-header">
  <div class="modal-title">{{title}}</div>
  <button id="low-value-notice-close" type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true"></span>
  </button>
</div>

<div class="modal-body">
  <p class="text-center" *ngIf="!showInnerHtml">
    {{message}}
  </p>
  <ng-container *ngIf="showInnerHtml">
    <div [innerHTML]="message"></div>
  </ng-container>
</div>

<div class="modal-footer">
  <button id="add-interim-popup-cancel" type="button" class="button secondary__button large__button position-static"
          (click)="onClose()">{{cancelButtonText}}</button>
  <button id="add-interim-popup-add" type="button" class="button primary__button large__button position-static"
          (click)="onConfirm()">{{confirmButtonText}}</button>
</div>
